import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet'
import ReactHtmlParser from 'react-html-parser';
import styled from 'styled-components';
import Img from 'react-image';

import { EventDetail} from '../components/Event'
class EventPage extends Component {
  static contextTypes = {
    firebase: PropTypes.object,
  };

  state = {
    event:{}
  };

  componentDidMount() {
    let event = this.props.pathContext.data;
    this.setState({event:event});
  }

  render() {
    const event = this.state.event;
    if(event && event.html) {
      return (
        <div>
          <Helmet title={event.title}
                  meta={[
                    {name: 'description', content: event.description},
                    {property: 'og:itle', content: event.title},
                    {property: 'og:description', content: event.description},
                  ]}
          />
          <EventDetail event={event} {...this.props} />
        </div>
      );
    } else {
      return <div></div>
    }
  }
}

export default EventPage;



// WEBPACK FOOTER //
// ./src/templates/event.js